import { ele } from "cables-shared-client";
import api from "../../api.js";
import web from "../../index.js";

export default class PageTeam
{
    constructor(targetElement)
    {
        const teamId = targetElement.dataset.teamid;
        const namespacesJson = targetElement.dataset.namespacesjson;
        const extensionsJson = targetElement.dataset.extensionsjson;

        this.getTeamProjects(teamId, "teamProjects");
        this.getTeamPatchLists(teamId, ele.byId("teamPatchLists"));

        const namespaces = web.parseDustJson(namespacesJson, []);
        const extensions = web.parseDustJson(extensionsJson, []);

        this.getTeamNamespaceOps(namespaces, ele.byId("teamNamespaces"));
        this.getTeamExtensionOps(extensions, ele.byId("teamExtensions"));
    }

    requestTeamAccess(teamId, permission = false)
    {
        const data = {};
        if (permission) data.permission = permission;

        api.post("teaminvites/request/" + teamId, data, (result) =>
        {
            ele.hide(ele.byId("request-access-button"));
            ele.show(ele.byId("request-pending-text"));
        });
    }

    joinTeam(teamId, permission = false)
    {
        const data = {};
        if (permission) data.permission = permission;

        const joinButton = ele.byId("join-team-button");
        web.buttons.startSavingAnimButton(joinButton);
        api.post("teams/join/" + teamId, data, (result) =>
        {
            if (result.success)
            {
                window.location.reload();
            }
        }, (err) =>
        {
            web.buttons.stopSavingAnimButton();
        });
    }

    leaveTeam(teamId)
    {
        const data = {};
        const joinButton = ele.byId("leave-team-button");
        web.buttons.startSavingAnimButton(joinButton);
        api.post("teams/leave/" + teamId, data, (result) =>
        {
            if (result.success)
            {
                window.location.href = "/myteams";
            }
        }, (err) =>
        {
            web.buttons.stopSavingAnimButton();
        });
    }

    _getOpsList(cssClass, ops, headlineIcon = null)
    {
        const deprecatedNs = ".Deprecated";
        let html = "";
        // if (ops.length > 0)
        {
            const splitNamespaces = {};
            ops.forEach((op) =>
            {
                let nsPath = op.name.substr(0, op.name.lastIndexOf("." + op.shortName));
                if (nsPath.endsWith(deprecatedNs)) nsPath = op.name.substr(0, op.name.lastIndexOf(deprecatedNs));

                if (!splitNamespaces.hasOwnProperty(nsPath))
                {
                    splitNamespaces[nsPath] = {
                        "name": nsPath,
                        "ops": []
                    };
                }
                splitNamespaces[nsPath].ops.push(op);
            });

            const keys = Object.keys(splitNamespaces).sort((a, b) => { return a.localeCompare(b); });
            keys.forEach((i) =>
            {
                const splitNamespace = splitNamespaces[i];
                let headlineHtml = web.getHandleBarHtml("headline", { "splitter": true, "link": "/ops/" + splitNamespace.name, "icon": headlineIcon, "title": splitNamespace.name });
                html += headlineHtml + "<section class=\"project-list\"><div class=\"row\"><div class=\"cute-12-phone left cute-12-tablet center-tablet \">";

                const deprecatedOps = splitNamespace.ops.filter((op) => { return op.name.includes(deprecatedNs); });
                const visibleOps = splitNamespace.ops.filter((op) => { return !op.name.includes(deprecatedNs); });

                if (visibleOps.length)
                {
                    html += "<div class=\"row " + cssClass + " " + splitNamespace.name + "\">";
                    visibleOps.forEach((op) =>
                    {
                        html += web.getHandleBarHtml("projectop", op);
                    });
                    html += "</div>";
                }
                else
                {
                    html += "No ops in this namespace";
                }

                if (deprecatedOps.length)
                {
                    const optTitle = deprecatedOps.length > 1 ? "ops" : "op";
                    html += visibleOps.length === 0 ? ", but " : "+";
                    html += deprecatedOps.length + " <a href=\"/ops/" + splitNamespace.name + "\">deprecated " + optTitle + "</a>";
                }
                html += "</div></div></section>";
            });
        }
        return html;
    }

    getTeamNamespaceOps(namespaces, targetEl)
    {
        if (!namespaces || !targetEl || namespaces.length === 0) return;

        namespaces.forEach((namespace) =>
        {
            let url = "teams/namespace/" + namespace + "/ops?deprecated=true";
            let html = "";
            api.get(url, (result) =>
            {
                html = this._getOpsList("teamNamespaceOps", result.data.ops);
                targetEl.innerHTML += html;
            }, (e) =>
            {
                html += "<div class=\"emptyState cute-12-phone left cute-12-tablet center-tablet\"><h3><span class=\"icon icon-alert-triangle icon-warning icon-near-text left\"></span>Error while getting namespace ops!</h3><br/></div>";
                html += "</div></div></section></div>";
                targetEl.innerHTML += html;
            });
        });
    }

    getTeamExtensionOps(namespaces, targetEl)
    {
        if (!namespaces || !targetEl || namespaces.length === 0) return;

        namespaces.forEach((namespace) =>
        {
            let url = "extension/" + namespace + "/ops?deprecated=true";
            let html = "";
            api.get(url, (result) =>
            {
                html = this._getOpsList("teamExtensionOps", result.data.ops);
                targetEl.innerHTML += html;
            }, (e) =>
            {
                html += "<div class=\"emptyState cute-12-phone left cute-12-tablet center-tablet\"><h3><span class=\"icon icon-alert-triangle icon-warning icon-near-text left\"></span>Error while getting namespace ops!</h3><br/></div>";
                html += "</div></div></section></div>";
                targetEl.innerHTML += html;
            });
        });
    }

    getTeamProjects(teamId, targetElId)
    {
        const url = new URL(window.location.href);
        let limit = url.searchParams.get("l") || 48;
        let offset = url.searchParams.get("o");
        limit = Number(limit);
        offset = Number(offset);

        let apiUrl = "teams/" + teamId + "/projects";
        if (offset)
        {
            apiUrl += "?o=" + offset;
        }
        if (limit || limit === 0)
        {
            if (offset)
            {
                apiUrl += "&l=" + limit;
            }
            else
            {
                apiUrl += "?l=" + limit;
            }
        }

        api.get(apiUrl, (result) =>
        {
            const containerEl = ele.byId("patches");
            if (result && result.projects.length > 0) ele.show(containerEl);
            web.projectPagePatchList(result.projects, targetElId, "No patches found", result.pagination);
            if (result.pagination)
            {
                web.tabs.initPagination(containerEl, result.pagination, limit, offset, (newLimit, newOffset) =>
                {
                    let newSearch = "";
                    if (newOffset)
                    {
                        newSearch += "?o=" + newOffset;
                    }
                    if (newLimit || newLimit === 0)
                    {
                        if (newOffset)
                        {
                            newSearch += "&l=" + newLimit;
                        }
                        else
                        {
                            newSearch += "?l=" + newLimit;
                        }
                    }
                    window.location = location.origin + location.pathname + newSearch + "#" + targetElId;
                });
            }
        });
    }

    getTeamPatchLists(teamId, targetEl)
    {
        if (!teamId || !targetEl) return;

        const container = ele.byId("patchlists");
        const apiUrl = web.tabs.addPagination("/patchlists/team/" + teamId);
        api.get(apiUrl, (res) =>
        {
            if (container) ele.hide(container);
            let html = "";
            if (res.data.length > 0)
            {
                res.data.forEach((list) =>
                {
                    const projectInfo = web.getHandleBarHtml("project_info", { "project": list, "user": { "_id": list.owner._id, "username": list.owner.username }, "displayedDate": "updated", "isPatchlist": true });
                    html += web.getHandleBarHtml("patchlist", { "list": list, "projectInfo": projectInfo });
                });
                targetEl.innerHTML = html;
                web.tabs.initPagination(targetEl, res.pagination);
                if (container) ele.show(container);
            }
        }, (e) =>
        {
            console.error(e);
            if (container) ele.hide(container);
        });
    }
}
